import { useLocaleStore } from '../store/locale.store';
import { formatNumber, formatTimeOnly } from '../utils/intl-locale';
import { formatDate, formatDayMonth } from '../utils/locale-format';
import { useLocaleSettings } from './useLocaleSettings';

/**
 * Formateadores ligados al idioma activo (es/en/zh) para números y horas.
 * Las fechas siguen `locale.dateFormat` de la empresa: el idioma de la interfaz
 * no cambia el orden día/mes/año.
 */
export function useIntlFormat() {
  const locale = useLocaleStore((s) => s.locale);
  const { dateFormat } = useLocaleSettings();
  return {
    locale,
    fmtNum: (v: number, o?: Intl.NumberFormatOptions) => formatNumber(v, locale, o),
    fmtDateTime: (v: Date | string | number) => {
      const date = new Date(v);
      return `${formatDate(date, dateFormat)} ${formatTimeOnly(date, locale, { hour: '2-digit', minute: '2-digit' })}`;
    },
    fmtDateOnly: (v: Date | string | number) => formatDate(new Date(v), dateFormat),
    /** Dia y mes de una fecha ISO (YYYY-MM-DD) en el formato de la empresa, sin corrimiento por UTC (ejes/tooltips de graficas). */
    fmtDayMonth: (v: string) => /^\d{4}-\d{2}-\d{2}/.test(v) ? formatDayMonth(v.slice(0, 10), dateFormat) : v,
    fmtTimeOnly: (v: Date | string | number, o?: Intl.DateTimeFormatOptions) => formatTimeOnly(v, locale, o),
  };
}
